(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["returns"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.aok_ret_x7z9_faq_question').forEach(question => {
  question.addEventListener('click', () => {
    const item = question.parentNode;
    item.classList.toggle('active');
  });
});

var chatIcon = document.getElementById('aokRet_x7z9_chatIcon');
if (chatIcon) {
  chatIcon.addEventListener('click', function() {
    console.log('Chat icon clicked - would open chat plugin');
  });
}

  } catch(e) { console.error(e); }
})();
})();
